import {Component, EventEmitter, Input, Output} from '@angular/core'
import {CatalogueLink} from '../../models/cataloguelink.model'

@Component(
    {
        selector: `app-mobile-menu-card`,
        templateUrl: `./mobile-menu-card.component.html`,
        styleUrls: [
            `./mobile-menu-card.component.scss`
        ]
    }
)
export class MobileMenuCardComponent {
    @Input() public showBackButton: boolean = true
    @Input() public showLinkToOutlet: boolean = false
    @Input() public hierarchy: CatalogueLink
    @Output() public backPressed: EventEmitter<void> = new EventEmitter<void>()
    @Output() public itemSelected: EventEmitter<CatalogueLink> = new EventEmitter<CatalogueLink>()
}
